import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Link2 } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });

export const RelinkMediaBox = ({ roomId, onRelinked }) => {
  const [orphans, setOrphans] = useState([]);
  const [sourceId, setSourceId] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/rooms/orphaned-media`, auth())
      .then(({ data }) => setOrphans(data.filter((o) => o.room_id !== roomId)))
      .catch(() => setOrphans([]));
  }, [roomId]);

  if (orphans.length === 0) return null;

  const handleRelink = async () => {
    if (!sourceId) return;
    if (!window.confirm('Preuzeti sadržaj sa stare sobe? Postojeći sadržaj ove sobe ostaje, popunjavaju se samo prazna polja i dodaju slike.')) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/rooms/${roomId}/relink`, { source_room_id: sourceId }, auth());
      toast.success('Sadržaj stare sobe je preuzet');
      onRelinked(data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Preuzimanje nije uspjelo');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-4 rounded-lg border border-amber-300 bg-amber-50" data-testid="relink-media-box">
      <p className="font-semibold text-amber-900 flex items-center gap-2"><Link2 className="w-4 h-4" /> Preuzmi sadržaj sa stare sobe</p>
      <p className="text-xs text-amber-900/80 mt-1">
        Ako ste u PMS-u promijenili ID jedinice, stari opis, slike i dodaci su sačuvani. Odaberite staru sobu i preuzmite ih ovdje.
      </p>
      <div className="flex flex-col sm:flex-row gap-2 mt-3">
        <select value={sourceId} onChange={(e) => setSourceId(e.target.value)} data-testid="relink-source-select"
          className="flex-1 border rounded-md px-3 py-2 text-sm bg-white">
          <option value="">Odaberi staru sobu…</option>
          {orphans.map((o) => (
            <option key={o.room_id} value={o.room_id}>
              {(o.room_name || 'Bez naziva')} — {o.images_count} slika{o.merged_into ? ' (već preuzeto)' : ''} — {o.room_id}
            </option>
          ))}
        </select>
        <Button onClick={handleRelink} disabled={!sourceId || busy} data-testid="relink-submit-btn"
          className="bg-amber-600 hover:bg-amber-700 text-white">
          {busy ? 'Preuzimam…' : 'Preuzmi sadržaj'}
        </Button>
      </div>
    </div>
  );
};
